import { render, staticRenderFns } from "./sorry.vue?vue&type=template&id=e18a72ec&scoped=true&"
import script from "./sorry.vue?vue&type=script&lang=js&"
export * from "./sorry.vue?vue&type=script&lang=js&"
import style0 from "./sorry.vue?vue&type=style&index=0&id=e18a72ec&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18a72ec",
  null
  
)

export default component.exports